<template>
  <div>
    <div class="main_box" v-if="examineList.length > 0">
      <van-steps direction="vertical" :active="activeIndex" active-color="#1989fa">
        <van-step v-for="(item,index) in examineList" :key="index">
          <span style="font-weight: bold">{{ item.sp_status == 2?'已通过':item.sp_status == 3?'驳回':'审批中' }}</span>
          <van-tag plain size="mini" type="primary" style="margin-left: 5px">{{ item.approverattr === 1? '或签' : '会签' }}</van-tag>
          <div v-for="(val,label) in item.details" :key="label">
            <div class="contLogSp">
              <van-image style="width: 0.6rem; height: 0.6rem" :src="val.avatar" ></van-image>
              <span style="margin-left: 10px;">{{val.userName}}</span>
              <van-tag style="margin-left: 30px;" size="mini" :type="val.sp_status == 2?'primary':val.sp_status == 3?'danger':'warning'">{{val.sp_status == 2?'已通过':val.sp_status == 3?'驳回':'审批中'}}</van-tag>
              <!-- <span v-if="val.spTime" style="margin-left: 10px;">{{val.spTime}}</span> -->
              <!-- <span style="margin-left: 50px;" v-if="val.spComment">{{ val.spComment }}</span> -->
            </div>
            <div v-if="val.spTime" style="margin-top: 5px;">{{val.spTime}}</div>
            <div v-if="val.speech" style="margin-top: 10px; color: #999; font-size: 12px;">“{{ val.speech }}”</div>
          </div>
        </van-step>
      </van-steps>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    logExamineArr: Array
  },
  watch: {
    logExamineArr: {
      immediate: true,
      handler(val, oldVal) {
        if (val) {
          this.examineList = val
          this.activeIndex = (this.examineList.findIndex(item => { return item.sp_status !== 2 })) - 1
        }
      }
    }
  },
  data() {
    return {
      examineList: [],
      activeIndex: null,
      spStatusOptions: this.$store.state.dictOptions.spStatus || [] // 审批状态
    }
  },
  async mounted() {

  },
  methods: {

    // 审批状态
    spStatusFormat(row, column, cellValue) {
      if (cellValue) {
        return this.selectDictLabel(this.spStatusOptions, cellValue)
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
.main_box{
  // min-height: 200px;
  // margin-top: 5px;
  // max-height: 620px;
  // overflow-y: scroll;
  .contLogSp{
    margin-top: 12px;
    margin-left: 10px;
    display: flex;
    align-items: center;
  }
}
/deep/ .el-timeline-item__wrapper{
  top: 0px;
}
/deep/ .el-timeline-item{
  padding-bottom: 0;
}
</style>
